var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 12"}},[_c('path',{attrs:{"d":"M29.15 2.29h-1.9V9.8h1.9V7h1.92V5.09h-1.92zM26.3.37h-2.81v4.75H8.38V.34H5.55v11.29h2.81V7h15.13v4.64h2.79zM4.62 2.29h-1.9v2.8H.93V7h1.81v2.78h1.9z"}})])};var toString = function () {return "/Users/JesseMaxwell/Sites/Blitz/src/assets/icons/lift.svg"};module.exports = { render: render, toString: toString };


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/lift.svg
// module id = XBbl
// module chunks = 1